export const ACCESS_CHANNEL_COUPON_SCENE = 2;

export interface ChannelCouponUtmParams {
  utmSource?: string | null;
  utmMedium?: string | null;
  utmCampaign?: string | null;
  referrer?: string | null;
}

export interface ChannelCouponParams {
  source: string;
  medium: string;
  campaign: string;
  forward_domains: string;
}

export interface AccessChannelCouponResource {
  scene?: number | string | null;
  strategy_id?: number | string | null;
  source?: string | null;
  medium?: string | null;
  campaign?: string | null;
  coupon_copy?: Record<string, unknown> | null;
}

export type ChannelCouponItem = Record<string, unknown> & {
  id?: number | string;
  is_get?: number;
};

export interface ReceiveChannelCouponPayload {
  strategy_id: number | string;
  source: string;
  medium: string;
  campaign: string;
}

export const buildChannelCouponParams = ({
  utmSource,
  utmMedium,
  utmCampaign,
  referrer,
}: ChannelCouponUtmParams): ChannelCouponParams | null => {
  const source = utmSource || '';
  const medium = utmMedium || '';
  const campaign = utmCampaign || '';

  if (!source && !medium && !campaign) {
    return null;
  }

  return {
    source,
    medium,
    campaign,
    forward_domains: referrer || '',
  };
};

export const isAccessChannelCoupon = (
  channelCoupon?: AccessChannelCouponResource | null,
): boolean =>
  Number(channelCoupon?.scene) === ACCESS_CHANNEL_COUPON_SCENE && !!channelCoupon?.strategy_id;

export const buildReceiveChannelCouponPayload = (
  channelCoupon?: AccessChannelCouponResource | null,
  fallbackParams?: Pick<ChannelCouponParams, 'source' | 'medium' | 'campaign'> | null,
): ReceiveChannelCouponPayload | null => {
  if (!isAccessChannelCoupon(channelCoupon)) {
    return null;
  }

  return {
    strategy_id: channelCoupon.strategy_id as number | string,
    source: channelCoupon.source || fallbackParams?.source || '',
    medium: channelCoupon.medium || fallbackParams?.medium || '',
    campaign: channelCoupon.campaign || fallbackParams?.campaign || '',
  };
};

export const filterReceivedChannelCoupons = (
  couponList: ChannelCouponItem[] = [],
  successDiscountCodeIds: Array<number | string> = [],
) => {
  if (!Array.isArray(couponList) || !Array.isArray(successDiscountCodeIds)) {
    return [];
  }

  const successIdSet = new Set(successDiscountCodeIds.map((id) => String(id)));

  return couponList
    .filter((coupon) => successIdSet.has(String(coupon?.id)))
    .map((coupon) => ({
      ...coupon,
      is_get: 2,
    }));
};

export const resolveAccessChannelCouponReceiveResult = (
  couponList: ChannelCouponItem[] = [],
  successDiscountCodeIds: Array<number | string> = [],
) => {
  const receivedCouponList = filterReceivedChannelCoupons(couponList, successDiscountCodeIds);

  return {
    receivedCouponList,
    shouldShowCouponDialog: receivedCouponList.length > 0,
    shouldStopFallback: true,
  };
};
